const removeKeys = ["DtaDelTime", "DtaDthTime"];
export const isRestored = (changes) => {
    return changes.some((ch) => {
        if (removeKeys.every((rk) => !ch.path.endsWith(rk))) return false;
        return ch.oldValue && !ch.newValue;
    })
}